import 'normalize.css'
// import 'bootstrap-css-only/css/bootstrap.css'; //bootstrap 4 va in conflitto con now ui kit
import 'font-awesome/css/font-awesome.min.css'
import 'leaflet/dist/leaflet.css'
import 'leaflet/dist/leaflet.js'
import 'angular-loading-bar/build/loading-bar.min.css'
import 'angular-growl-v2/build/angular-growl.min.css'
import angular from 'angular'
import uiRouter from 'angular-ui-router'
import angularLoadingBar from 'angular-loading-bar'
import angularDropdown from 'angular-ui-bootstrap/src/dropdown'
import angularCarousel from 'angular-ui-bootstrap/src/carousel'
import angularModal from 'angular-ui-bootstrap/src/modal'
import angularTranslate from 'angular-translate'
import angularAnimate from 'angular-animate'
import angularStorage from 'angular-storage'
import angularFileUpload from 'ng-file-upload'
import 'angular-growl-v2/build/angular-growl.min'
import 'angular-summernote/dist/angular-summernote.min'
import AppComponent from './app.component'
import Common from './common/common'
import Components from './components/components'
import ImageService from './services/imageService/image'
import AccountService from './services/accountService/account'
import ReportService from './services/reportService/report'

angular.module('app', [
  uiRouter,
  angularLoadingBar,
  angularDropdown,
  angularTranslate,
  angularStorage,
  angularAnimate,
  angularCarousel,
  angularModal,
  angularFileUpload,
  'angular-growl',
  'summernote', // vedi index.html per le dipendenze di summernote.js
  Common,
  Components,
  ImageService,
  AccountService,
    ReportService
]).config(($locationProvider, $urlRouterProvider) => {
  'ngInject'
  // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
  // #how-to-configure-your-server-to-work-with-html5mode
  // $locationProvider.html5Mode(true).hashPrefix('!');

  $urlRouterProvider.otherwise('/')
}).config(($translateProvider) => {
  'ngInject'

  $translateProvider.translations('it', {
    'CULTURE': "Cultura",
    'INFORMATION': "Informazioni",
    'ITINERARY': "Itinerari",
    'NATURE': 'Natura',
    'TYPICALPRODUCT': 'Prodotti tipici',
    'SERVICE': 'Servizi e ricettività',
    'OUTDOOR': 'Outdoor',
    'ITINERARY': 'Itinerari'
  })

  $translateProvider.preferredLanguage('it')
}).config(function (growlProvider) {
  'ngInject'
  growlProvider.globalTimeToLive(5000)
  growlProvider.globalDisableCountDown(true)
  growlProvider.globalPosition('top-center')
}).config(function (cfpLoadingBarProvider) {
  'ngInject'
  cfpLoadingBarProvider.spinnerTemplate =
    '<div class="sk-cube-grid">' +
    '  <div class="sk-cube sk-cube1"></div>' +
    '  <div class="sk-cube sk-cube2"></div>' +
    '  <div class="sk-cube sk-cube3"></div>' +
    '  <div class="sk-cube sk-cube4"></div>' +
    '  <div class="sk-cube sk-cube5"></div>' +
    '  <div class="sk-cube sk-cube6"></div>' +
    '  <div class="sk-cube sk-cube7"></div>' +
    '  <div class="sk-cube sk-cube8"></div>' +
    '  <div class="sk-cube sk-cube9"></div>' +
    '</div>';

  // '<div class="loading">' +
  // '  <span>Caricamento...</span>' +
  // '</div>'
})
.config(function ($qProvider) {
  'ngInject'
  $qProvider.errorOnUnhandledRejections(false);
})
.config(function ($httpProvider) {
  'ngInject'
  $httpProvider.interceptors.push('Auth');
})
/* .constant('SERVER_URL', 'http://localhost:8080/api') */
.constant('SERVER_URL', 'https://www.api.parco.nino.cloud/api')

.run(function ($http, store, $state, $location) {
  'ngInject'

  if (store.get("token")
    && $location.path().indexOf("confirmRegistration") == -1) {
    $http.defaults.headers.common.Authorization = store.get("token");

    // Reindirizza alla dashboard solo se c'è un token valido
    // e l'utente è sulla pagina di login.
    if ($location.path() === '' || $location.path() === '/' || $location.path().indexOf("login") > -1) {
      $state.go("dashboard.list", {modelEnum: 'CULTURE'});
    }

  }

}).component('app', AppComponent)



// WEBPACK FOOTER //
// ./client/app/app.js